import React, { useEffect, useState } from 'react';
import { getAllIncome, getFamilyStatus, getFamilyType, getFamilyValue, submitLifeStyleFamily } from '../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { familyDetailSchema } from '../ValidationSchema';
import { Grid } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

function LifeStyleFamilyForm() {
    const [familyTypes, setFamilyTypes] = useState([]);
    const [familyStatuses, setFamilyStatuses] = useState([]);
    const [familyValues, setFamilyValues] = useState([]);
    const [incomes, setIncomes] = useState([]);
    // const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const initialValues = {
        familyType: '',
        familyStatus: '',
        familyValue: '',
        fatherName: '',
        motherName: '',
        fatherProfessions: '',
        motherProfession: '',
        marriedBrothers: '',
        unMarriedBrothers: '',
        marriedSister: '',
        unMarriedSister: '',
        familyOrigin: '',
        aboutFamily: '',
        // tokan: token,
        user_id: localStorage.getItem('user'),
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [familyValueRes, familyTypeRes, familyStatusRes] = await Promise.all([
                    getFamilyValue(),
                    getFamilyType(),
                    getFamilyStatus(),
                ]);
                if (familyValueRes.status === 200 || familyValueRes.status === 201) {
                    setFamilyValues(familyValueRes.data.data);
                }

                if (familyTypeRes.status === 200 || familyTypeRes.status === 201) {
                    setFamilyTypes(familyTypeRes.data.data);
                }

                if (familyStatusRes.status === 200 || familyStatusRes.status === 201) {
                    setFamilyStatuses(familyStatusRes.data.data);
                }
            } catch (error) {
                toast.error(error.response?.data?.message || 'Failed to fetch data');
            }
        }

        const fetchIncome = async () => {
            try {
                const response = await getAllIncome();
                if (response.status === 200 || response.status === 201) {
                    setIncomes(response.data.data);
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.response?.data?.message);
            }
        };

        fetchData();
        fetchIncome();
    }, []);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            const response = await submitLifeStyleFamily(values);
            if (response.status === 200 || response.status === 201) {
                localStorage.setItem('last_complete_step', response.data.last_complete_step);
                toast.success('Lifestyle and family details updated successfully');
                navigate('/my_matches');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section className="siteForm">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-5">
                        <div className="formTitle mt-5 pt-5 d-flex justify-content-between align-items-between">
                            <h3>Family Details</h3>
                            {/* <p className="skipBtn"><a href="#">SKIP</a></p> */}
                            <Link className='skipBtn' to="/">SKIP</Link>
                        </div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={familyDetailSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ isSubmitting, handleChange, values }) => (
                                <Form className="mt-4">
                                    <div className="mb-3">
                                        <label className="form-label">Family Value</label>
                                        <Field
                                            as="select"
                                            name="familyValue"
                                            className="form-select"
                                            onChange={handleChange}
                                            value={values.familyValue}
                                        >
                                            <option value="">Select Family Value</option>
                                            {familyValues.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="familyValue" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Family Type</label>
                                        <Field
                                            as="select"
                                            name="familyType"
                                            className="form-select"
                                            onChange={handleChange}
                                            value={values.familyType}
                                        >
                                            <option value="">Select Family Type</option>
                                            {familyTypes.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="familyType" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Family Status</label>
                                        <Field
                                            as="select"
                                            name="familyStatus"
                                            className="form-select"
                                            onChange={handleChange}
                                            value={values.familyStatus}
                                        >
                                            <option value="">Select Family Status</option>
                                            {familyStatuses.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="familyStatus" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Father Name</label>
                                        <Field
                                            type="text"
                                            name="fatherName"
                                            className="form-control"
                                            placeholder="Father Name"
                                        />
                                        <ErrorMessage name="fatherName" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Father's Profession</label>
                                        <Field
                                            type="text"
                                            name="fatherProfessions"
                                            className="form-control"
                                            placeholder="Father's Profession"
                                        />
                                        <ErrorMessage name="fatherProfessions" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Mother Name</label>
                                        <Field
                                            type="text"
                                            name="motherName"
                                            className="form-control"
                                            placeholder="Mother Name"
                                        />
                                        <ErrorMessage name="motherName" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Mother's Profession</label>
                                        <Field
                                            type="text"
                                            name="motherProfession"
                                            className="form-control"
                                            placeholder="Mother's Profession"
                                        />
                                        <ErrorMessage name="motherProfession" component="div" className="text-danger" />
                                    </div>

                                    <h5>Brothers</h5>
                                    <Grid container spacing={2} className="mb-3">
                                        <Grid item xs={6}>
                                            <label className="form-label">Married Brothers</label>
                                            <Field
                                                as="select"
                                                name="marriedBrothers"
                                                className="form-select"
                                                onChange={handleChange}
                                                value={values.marriedBrothers}
                                            >
                                                <option value="">Select</option>
                                                {[...Array(6)].map((_, i) => (
                                                    <option key={i} value={i}>{i}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="marriedBrothers" component="div" className="text-danger" />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <label className="form-label">Unmarried Brothers</label>
                                            <Field
                                                as="select"
                                                name="unMarriedBrothers"
                                                className="form-select"
                                                onChange={handleChange}
                                                value={values.unMarriedBrothers}
                                            >
                                                <option value="">Select</option>
                                                {[...Array(6)].map((_, i) => (
                                                    <option key={i} value={i}>{i}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="unMarriedBrothers" component="div" className="text-danger" />
                                        </Grid>
                                    </Grid>
                                    <h5>Sisters</h5>
                                    <Grid container spacing={2} className="mb-3">
                                        <Grid item xs={6}>
                                            <label className="form-label">Married Sisters</label>
                                            <Field
                                                as="select"
                                                name="marriedSister"
                                                className="form-select"
                                                onChange={handleChange}
                                                value={values.marriedSister}
                                            >
                                                <option value="">Select</option>
                                                {[...Array(6)].map((_, i) => (
                                                    <option key={i} value={i}>{i}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="marriedSister" component="div" className="text-danger" />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <label className="form-label">Unmarried Sisters</label>
                                            <Field
                                                as="select"
                                                name="unMarriedSister"
                                                className="form-select"
                                                onChange={handleChange}
                                                value={values.unMarriedSister}
                                            >
                                                <option value="">Select</option>
                                                {[...Array(6)].map((_, i) => (
                                                    <option key={i} value={i}>{i}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="unMarriedSister" component="div" className="text-danger" />
                                        </Grid>
                                    </Grid>

                                    <div className="mb-3">
                                        <label className="form-label">Family Native Place</label>
                                        <Field
                                            type="text"
                                            name="familyOrigin"
                                            className="form-control"
                                            placeholder="Family Native Place"
                                        />
                                        <ErrorMessage name="familyOrigin" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">About My Family</label>
                                        <Field
                                            as="textarea"
                                            name="aboutFamily"
                                            className="form-control"
                                            placeholder="About My Family"
                                            rows="3"
                                        />
                                    </div>

                                    {/* <div className="mb-3 d-grid col-12 mx-auto">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={isSubmitting}
                                        >
                                            Save & Continue
                                        </button>
                                    </div> */}
                                    <div className="mb-3 d-grid col-12 mx-auto">
                                        <button type="submit" className="btn btn-primary formBtn" disabled={isSubmitting}>
                                            {isSubmitting ? 'Submitting...' : 'Complete Registration'}
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <br />
                        <br />
                    </div>
                </div>
                <ToastContainer />
            </div>
        </section>
    );
}

export default LifeStyleFamilyForm;
